import type { NormalizedChart } from './domain.js';
import type { ChronologyResolution } from './chronology.js';

export interface ChronologyResolutionViewModel {
  mode: ChronologyResolution['mode'];
  modeLabel: 'Standard Chronology' | 'Extended Chronology';
  badge: '正式' | '研究';
  provider: string;
  validationLabel: '正式驗證範圍' | '研究／未正式驗證';
  inValidatedRange: boolean;
  disclosure: string;
}

export interface CalculationContextViewModel {
  engine: string;
  calculationRuleset: string;
  chronology?: Readonly<{
    birth: ChronologyResolutionViewModel;
    target?: ChronologyResolutionViewModel;
  }>;
  disclosure: string;
}

export function chronologyResolutionViewModel(resolution: ChronologyResolution): ChronologyResolutionViewModel {
  const formal = resolution.mode === 'standard'
    && resolution.validationStatus === 'verified_range'
    && resolution.inValidatedRange;
  return Object.freeze({
    mode: resolution.mode,
    modeLabel: resolution.mode === 'standard' ? 'Standard Chronology' : 'Extended Chronology',
    badge: formal ? '正式' : '研究',
    provider: `${resolution.providerId}@${resolution.providerVersion}`,
    validationLabel: formal ? '正式驗證範圍' : '研究／未正式驗證',
    inValidatedRange: resolution.inValidatedRange,
    disclosure: resolution.disclosure,
  });
}

export function buildCalculationContextViewModel(
  chart: NormalizedChart,
  chronology?: Readonly<{ birth: ChronologyResolution; target?: ChronologyResolution }>,
): CalculationContextViewModel {
  const presentedChronology = chronology
    ? Object.freeze({
        birth: chronologyResolutionViewModel(chronology.birth),
        ...(chronology.target ? { target: chronologyResolutionViewModel(chronology.target) } : {}),
      })
    : undefined;
  return Object.freeze({
    engine: `${chart.calculation.engine}@${chart.calculation.engineVersion}`,
    calculationRuleset: `${chart.calculation.rulesetId}@${chart.calculation.rulesetVersion}`,
    ...(presentedChronology ? { chronology: presentedChronology } : {}),
    disclosure: '此區顯示實際排盤引擎、Calculation Ruleset 與 Chronology Provider 版本；驗證狀態是工程 Regression 範圍，不是命理準確率。',
  });
}
